import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-h-column-list"
}
const _hoisted_2 = { class: "p-h-column-list__body" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SmallText = _resolveComponent("SmallText")!

  return (_ctx.listItem)
    ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listItem, ({ label, detail }, key) => {
          return (_openBlock(), _createElementBlock("li", {
            key: key,
            class: _normalizeClass(["p-h-column-list__item", _ctx.columnSizeClassName])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_SmallText, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(label), 1)
                ]),
                _: 2
              }, 1024),
              (typeof detail == 'string')
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_ctx.redemptionType === 3)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          innerHTML: _ctx.giftCode(detail)
                        }, null, 8, _hoisted_4))
                      : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.giftCode(_ctx.detailText)), 1))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(detail, (detailText, detailKey) => {
                      return (_openBlock(), _createElementBlock("p", {
                        key: detailKey,
                        class: "p-the-h03__text"
                      }, [
                        (_ctx.redemptionType === 3)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              innerHTML: _ctx.giftCode(detailText)
                            }, null, 8, _hoisted_7))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.giftCode(detailText)), 1))
                      ]))
                    }), 128))
                  ]))
            ])
          ], 2))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}